export default function About() {
    return (
        <section id="about" className="card">
            <h2 className="card__title">Über mich</h2>
            <p className="card__text">
                Mein beruflicher Weg begann in der Webentwicklung und führte über mehrere Jahre als
                Full-Stack-Entwickler in die Konzeption und Umsetzung umfangreicher Anwendungen vom
                Frontend bis in die Datenbank. Heute liegt mein Schwerpunkt auf
                On-Premise-Kubernetes-Engineering: Ich entwerfe, automatisiere und betreibe
                hochverfügbare Plattformen mit dem Ziel, Entwicklungsteams eine zuverlässige
                Self-Service-Infrastruktur bereitzustellen, die im Alltag einfach funktioniert.
            </p>
        </section>
    );
}
